<template>
	<EMCoreTemplate category="OSMLife" identity="commission" entity="osm_commission"></EMCoreTemplate>
</template>
<script type="text/javascript">
	import {EMCoreTemplate} from '@/Adm/components' 
	export default{
		components:{
			EMCoreTemplate
		}	
	}

</script>


// WEBPACK FOOTER //
// src/Adm/EntityManagementLife/containers/Commission.vue